import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase } from "../../../utils/constants/headersForApi";

export const openBoxApi = createApi({
    reducerPath: "openbox",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
    }),
    endpoints: (builder) => ({
        getInfoDefault: builder.query({
            query: () => ({
                url: "Openbox/getUserDefaultInfo",
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getRegioni: builder.query({
            query: () => ({
                url: "Openbox/getListRegioni",
                method: "GET",
                headers: headersBase(),
            }),
        }),

        getProvince: builder.query({
            query: (id) => ({
                url: `Openbox/getListProvince?codiceRegione=${id}`,
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getTipiServizi: builder.query({
            query: (id) => ({
                url: `Openbox/getTipologieServizi?codiceProvincia=${id}`,
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getSedi: builder.query({
            query: (id) => ({
                url: id ? `Openbox/getSedi?codiceProvincia=${id}` : "Openbox/getSedi",
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getServizi: builder.query({
            query: ({ service }) => ({
                url: `Openbox/getServizi?codiceProvincia=${service.provincia}&codiceTipologia=${service.tipologia}&codiceSede=${service.sede}`,
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getSportelli: builder.query({
            query: ({ sportello }) => ({
                url: `Openbox/getSportelli?codiceProvincia=${sportello.provincia}&codiceSede=${sportello.sede}`,
                method: "GET",
                headers: headersBase(),
            }),
        }),
        getSpots: builder.query({
            query: ({ spots }) => ({
                url: `Openbox/getAvailableSpots?codiceProvincia=${spots.provincia}&codiceSede=${spots.sede}&codiceServizio=${spots.servizio}`,
                method: "GET",
                headers: headersBase(),
            }),
        }),


    }),
});

export const {
    useGetInfoDefaultQuery,
    useGetRegioniQuery,
    useGetProvinceQuery,
    useGetTipiServiziQuery,
    useGetSediQuery,
    useGetServiziQuery,
    useGetSportelliQuery,
    useGetSpotsQuery
} = openBoxApi;
